import script from "./TermsAndConditionsLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditionsLink.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndConditionsLink.vue?vue&type=style&index=0&id=e80f6df6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e80f6df6"]])

export default __exports__